





























import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';

interface Option {
  label: string;
  value: string | number;
}
interface FormItem {
  label: string;
  type: string;
  options?: Option[];
}

@Component
export default class KBaseForm extends Vue {
  @PropSync('list') syncList!: FormItem[];
  @Prop() triggerSubmit!: boolean;

  formData = {};
  @Watch('triggerSubmit')
  onTriggerSubmitChange(val: boolean) {
    if (val == true) this.$emit('submit', this.formData);
  }
}
